import React, { useEffect, useState, Fragment } from 'react';
import { QuestionRendererProps } from './types';
import { LatexRenderer } from '../../ui/LatexRenderer';
export function NumberSequenceRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const config = question.interactiveConfig || {};
  const sequence = config.sequence || []; // [3, 7, 11, 15]
  const missingIndices = config.missingIndices || []; // [4] (index where input should be)
  // Map of index -> value
  const [inputs, setInputs] = useState<Record<number, string>>({});
  useEffect(() => {
    // Ready when all missing indices have a value
    const isReady = missingIndices.every((idx: number) => inputs[idx] && inputs[idx].trim() !== '');
    onReadyChange?.(isReady);
  }, [inputs, missingIndices, onReadyChange]);
  useEffect(() => {
    if (shouldValidate) {
      // Return comma-separated values in order of missingIndices
      const values = missingIndices.map((idx: number) => inputs[idx] || '').join(',');
      onAnswer(values);
    }
  }, [shouldValidate, inputs, missingIndices, onAnswer]);
  const handleChange = (index: number, value: string) => {
    setInputs(prev => ({
      ...prev,
      [index]: value
    }));
  };
  // Determine the full length to render
  // It's the max index in sequence or missingIndices + 1
  const maxIndex = Math.max(sequence.length, ...missingIndices) + 1;
  // Create array of items to render
  const items = [];
  for (let i = 0; i < maxIndex; i++) {
    if (missingIndices.includes(i)) {
      items.push({
        type: 'input',
        index: i
      });
    } else if (sequence[i] !== undefined) {
      items.push({
        type: 'static',
        value: sequence[i]
      });
    }
  }
  return <div className="w-full max-w-3xl mx-auto" data-id="element-1474">
      <div className="flex flex-wrap items-center justify-center gap-4" data-id="element-1475">
        {items.map((item, i) => <Fragment key={i} data-id="element-1476">
            {item.type === 'static' ? <div className="w-16 h-16 flex items-center justify-center bg-white border-2 border-slate-200 rounded-full text-xl font-bold text-slate-700 shadow-sm" data-id="element-1477">
                {item.value}
              </div> : <input type="number" value={inputs[item.index] || ''} onChange={e => handleChange(item.index, e.target.value)} className="w-16 h-16 text-center bg-white border-2 border-indigo-300 rounded-full text-xl font-bold text-indigo-700 shadow-sm focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 outline-none transition-all" placeholder="?" data-id="element-1478" />}

            {/* Arrow between items */}
            {i < items.length - 1 && <div className="text-slate-300" data-id="element-1479">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1480">
                  <line x1="5" y1="12" x2="19" y2="12" data-id="element-1481"></line>
                  <polyline points="12 5 19 12 12 19" data-id="element-1482"></polyline>
                </svg>
              </div>}
          </Fragment>)}
      </div>

      <p className="text-center text-slate-400 text-sm mt-8" data-id="element-1483">
        Vul de ontbrekende getallen in
      </p>
    </div>;
}